import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-upload-icon',
  templateUrl: './files-upload.component.html'
})
export class FilesUploadComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
